import moment from 'moment';

/* Принимает строку формата DD.MM.YYYY и возвращает день недели */
export const getDayOfTheWeek = date => {
  const formattedDate = date.split('.').reverse();
  const currentDate = new Date(formattedDate);
  const days = [
    'Воскресенье',
    'Понедельник',
    'Вторник',
    'Среда',
    'Четверг',
    'Пятница',
    'Суббота',
  ];

  return days[currentDate.getDay()];
};

export const getMonth = date => {
  const currentDate = date.split('.')[1] - 1;
  const month = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
  ];

  return month[currentDate];
};

export const getDayWithMonth = date => {
  const day = date.split('.')[0];

  return `${day} ${getMonth(date)}`;
};

export const getMomentOfSession = (day, time) => {
  moment.locale('ru');
  return moment(`${day} ${time}`, 'DD.MM.YYYY HH:mm');
}